// src/pages/TwoFAPage.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getApiUrl } from '../utils/apiConfig';

function TwoFAPage() {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(getApiUrl('/api/auth/2fa/verify'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ token }),
      });

      const data = await response.json();

      if (response.ok) {
        login();
        navigate('/dashboard');
      } else {
        setError(data.message || '2FA fehlgeschlagen');
      }
    } catch (err) {
      console.error(err);
      setError('Server nicht erreichbar');
    }
  };

  return (
    <div className="twofa-container">
      <h2>2FA Code eingeben</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Code aus Authenticator-App"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          required
        />
        <button type="submit">Verifizieren</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}

export default TwoFAPage;
